import type {DesignSelection} from '@/components/social-media/social-media.types';
import type {CropData} from '@Panels/cropper-panel';
import type {PanelMessageProp} from '@Components/panel/panel.types';
import {PANEL_MESSAGE_TYPE} from '@Components/panel/panel.types';

export const PANEL_ID = 'social-media-select-cover-panel';

export const UNABLE_TO_GENERATE_COVER_ERROR_PANEL_MSG: PanelMessageProp = {
  type: PANEL_MESSAGE_TYPE.ERROR,
  message: window.i18next.t('pmwjs_unable_to_generate_cover'),
};

export const SHOW_TOOLTIP_AFTER_SECS = 500;
export const HIDE_TOOLTIP_AFTER_SECS = 6000;
export const PORTRAIT_ASPECT_RATIO_MODAL_HEIGHT_PX = 583;
export const SQUARE_ASPECT_RATIO_MODAL_HEIGHT_PX = 552;
export const COVER_PANEL_FOOTER_PRIMARY_ACTION_KEY = 'select-cover-panel-primary-action-footer-key';
export const SEEKER_PREVIEW_BOTTOM_PADDING_CLASS = 'spacing-p-b-10';

export enum CoverSource {
  UPLOAD = 'UPLOAD',
  DESIGN = 'DESIGN',
}

export interface SocialPostCoverParams {
  source: CoverSource;
  uploadedCoverPostParams?: {
    uploadImageHashedFileName: string;
    uploadImageFileExtension: string;
    cropData: CropData;
  };
  timestampedCoverParams?: {
    graphicUrl: string;
    timestamp: number;
    idAccount: number;
    idPost: string;
    design: DesignSelection;
  };
}

export const getFlattenedSocialPostCoverParams = (params: SocialPostCoverParams): Record<string, any> => {
  const flatParams: Record<string, any> = {
    source: params.source,
  };

  if (params.uploadedCoverPostParams) {
    flatParams.uploadImageHashedFileName = params.uploadedCoverPostParams.uploadImageHashedFileName;
    flatParams.uploadImageFileExtension = params.uploadedCoverPostParams.uploadImageFileExtension;

    const {cropData} = params.uploadedCoverPostParams;

    flatParams.x = cropData.x;
    flatParams.y = cropData.y;
    flatParams.width = cropData.width;
    flatParams.height = cropData.height;
    flatParams.imageWidth = cropData.imageWidth;
    flatParams.imageHeight = cropData.imageHeight;
  }

  if (params.timestampedCoverParams) {
    flatParams.graphicUrl = params.timestampedCoverParams.graphicUrl;
    flatParams.timestamp = params.timestampedCoverParams.timestamp;
    flatParams.idAccount = params.timestampedCoverParams.idAccount;
    flatParams.idPost = params.timestampedCoverParams.idPost;
    flatParams.idPoster = params.timestampedCoverParams.design.posterHashedId;
    flatParams.idPage = params.timestampedCoverParams.design.pageHashedId;
  }

  return flatParams;
};
